module.exports = __webpack_public_path__ + "img/UT0418.6fc01abc.png";